<template>
    <div>
        <v-data-table
                :headers="headers"
                :items="students"
                :loading="loading"
                :server-items-length="students.length"
                class="elevation-3"
                hide-default-footer
        >
            <template v-slot:item="props">
                <tr :class="{'red lighten-5': props.item.countAbsences > 0}">
                    <td class="text-xs-left">{{ `${props.item.surname} ${props.item.name} ${props.item.patronymic}` }}</td>
                    <td class="text-xs-left">{{ props.item.semester.yearNumber }}</td>
                    <td class="text-xs-left">{{ props.item.speciality.nameUk }}</td>
                    <td class="text-xs-left">{{ `${props.item.academicGroup.groupNumber} група` }}</td>
                    <td class="text-xs-left">{{ props.item.countNotPassed }}</td>
                    <td class="justify-center layout px-0">
                        <div class="d-flex align-center">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" icon class="mx-0" @click="openAdmissionsByStudent(props.item)">
                                        <v-icon color="primary">assignment</v-icon>
                                    </v-btn>
                                </template>
                                <span>Переглянути незараховані ПМК</span>
                            </v-tooltip>
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <v-dialog v-model="moduleReworksPerStudentDialog"
                  fullscreen
                  persistent
                  hide-overlay
                  transition="dialog-bottom-transition"
                  scrollable>
            <module-reworks-list-per-student
                    v-if="moduleReworksPerStudentDialog"
                    @shouldCloseAddEdit="moduleReworksPerStudentDialog = false"
                    :student="selectedStudent"
            ></module-reworks-list-per-student>
        </v-dialog>
    </div>
</template>
<script>
    import {reworkModeEnum} from "../../../constants/_internal/reworkModeEnum";
    import ModuleReworksListPerStudent from "./ModuleReworksListPerStudent";

    export default {
        components: {
            ModuleReworksListPerStudent,
        },
        data: () => ({
            moduleReworksDetailDialog: false,
            selectedStudent: null,
            headers: [
                {text: 'ПІП', sortable: false},
                {text: 'Курс', sortable: false},
                {text: 'Спеціальність', sortable: false},
                {text: 'Академічна група', sortable: false},
                {text: 'Кількість незарахованих ПМК', sortable: false},
                {text: 'Дії', sortable: false}
            ],
            moduleReworksPerStudentDialog: false,
            reworkModeEnum
        }),
        props: {
            students: Array,
            loading: Boolean,
        },
        methods: {
            openAdmissionsByStudent(student) {
                this.selectedStudent = student;
                this.moduleReworksPerStudentDialog = true;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .reworks-list-dialog {
        overflow-y: unset !important;
    }
</style>